import { render, staticRenderFns } from "./MyPost.vue?vue&type=template&id=036df04b&"
import script from "./MyPost.vue?vue&type=script&lang=js&"
export * from "./MyPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/MyPost.vue"
export default component.exports